import { render, staticRenderFns } from "./CustomDatePicker.vue?vue&type=template&id=65dd8ecc&"
import script from "./CustomDatePicker.vue?vue&type=script&lang=js&"
export * from "./CustomDatePicker.vue?vue&type=script&lang=js&"
import style0 from "./CustomDatePicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports